import { getEnv } from "@/utils";
import APIAbstract from "./apiAbstract";

export default class PollsApi extends APIAbstract {
  constructor() {
    super({
      baseUrl: `${getEnv("treebalApiUrlPoll", "notSet")}`,
      basePath: "api/v1/polls",
    });
  }
}
